import * as Yup from "yup";

export interface IUser {
  username: string,
  password: string,
}

export interface IAuthContext {

  isAuthenticated: boolean
  logout: () => void
  //eslint-disable-next-line no-unused-vars
  login: ( user: IUser ) =>
    Promise<string | void>
}

export const userValidationSchema = Yup.object({
  username: Yup.string().required("Usuário : Campo obrigatório"),
  password: Yup.string().required("Senha : Campo obrigatório"),
});

